/**
 * Convert a file selected from input to base64.
 * @param file Input file target.
 * @returns file base64 code.
 */
export const toBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result + '');
    reader.onerror = reject;
  });

/**
 * Convert blob to base64.
 * @param blob image blob content.
 * @returns blob content to base64.
 */
export const blobToBase64 = (blob: Blob) => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

/**
 * Check if file has a valid extension.
 * @param extension file extension.
 * @returns is valid extension.
 */
export const isValidExtension = (extension: string): boolean => {
  switch(extension) {
    case '.csv': 
    case '.pdf': 
    case '.jpg': 
    case '.png': 
    case '.jpeg': 
    case '.pptx': 
    case '.ppsx': 
    case '.odp': 
    case '.docx': 
    case '.xlsx': 
      return true;
    default:
      return false;
  }
}

/**
 * Check if file size is less than 10MB.
 * @param bytes number of bytes from file.
 * @returns file size is valid.
 */
export const isValidSize = (bytes: number): boolean => bytesToMegaBytes(bytes) <= 10 ? true : false;

/**
 * Convert bytes to mega bytes.
 * @param bytes number of bytes from file.
 * @returns MB size of file.
 */
export const bytesToMegaBytes = (bytes: number): number => Number((bytes / (1024*1024)).toFixed(2));

/**
 * Downlaod blob content file.
 * @param fileName File name with extension.
 * @param blob File blob content.
 */
export const downloadBlobFile = (fileName: string, blob: Blob): void => {
  const url = window.URL.createObjectURL(blob);
  const a = window.document.createElement('a');
  a.href = url;
  a.download = fileName,
  window.document.body.appendChild(a);
  a.click();
  window.document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}